"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _material = require("@mui/material");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _features = require("../../../../Shared/store/features");

var _PersonalIntegration = require("../../../../PersonalIntegration");

var _useCalendarIntegration = require("../../../../PersonalIntegration/hooks/useCalendarIntegration");

var _personalIntegration = require("../../../../PersonalIntegration/store/personalIntegration/personalIntegration.reducer");

var ChiliPiperLogo = function ChiliPiperLogo(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.407 6.765c.237.118.529.051.66-.178a.47.47 0 0 0-.168-.637 9.024 9.024 0 0 0-.832-.445.574.574 0 0 1-.303-.69c.45-1.43.54-2.966.26-4.438a.45.45 0 0 0-.8-.202c-.068.083-.135.169-.2.255a.523.523 0 0 0-.103.289 9.006 9.006 0 0 1-1.039 3.737.523.523 0 0 1-.532.264 9.172 9.172 0 0 0-1.46-.064.339.339 0 0 0-.3.225.364.364 0 0 0 .284.488 14.63 14.63 0 0 1 4.533 1.396z",
    fill: "#FF5721"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.102 12.608a.519.519 0 0 0 .275.787c1.224.36 2.47.577 3.715.66a1.439 1.439 0 0 0 1.327-.7 23.605 23.605 0 0 0 1.566-3.104 1.196 1.196 0 0 0-.43-1.458 14.583 14.583 0 0 0-7.682-2.464c-.624-.02-1.14.451-1.264 1.064a23.62 23.62 0 0 1-.104.485l-.006.026-.012.053-.033.145a23.506 23.506 0 0 1-.957 3.103.52.52 0 0 0 .223.644c.376.212.76.41 1.15.595.256.12.559.007.675-.25a21.526 21.526 0 0 0 1.34-3.984c.032-.142.158-.241.302-.234l.09.005c.597.034 1.062.064 1.624.359.166.086.23.286.162.46a20.313 20.313 0 0 1-1.961 3.808z",
    fill: "#FF5721"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.098 13.838c.28.14.388.488.22.751a23.888 23.888 0 0 1-1.73 2.377c-.175.212.1.515.307.335.892-.775 1.731-1.61 2.507-2.502a.541.541 0 0 1 .59-.153c1.306.467 2.643.769 3.985.912.345.037.52.443.292.704a23.89 23.89 0 0 1-3.33 3.14 2.27 2.27 0 0 1-1.753.459 15.006 15.006 0 0 1-5.076-1.805.517.517 0 0 1-.127-.78A23.82 23.82 0 0 0 9.49 13.59a.547.547 0 0 1 .748-.209c.282.16.569.314.86.458zM6.004 19.172a.545.545 0 0 0-.668.053 23.9 23.9 0 0 1-4.961 3.526c-.611.325-.438 1.27.254 1.25a23.806 23.806 0 0 0 7.214-1.339 23.673 23.673 0 0 0 2.452-1.024c.247-.12.201-.484-.063-.557a14.942 14.942 0 0 1-4.228-1.909z",
    fill: "#FF5721"
  }));
};

ChiliPiperLogo.defaultProps = {
  width: "22",
  height: "24",
  viewBox: "0 0 22 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var GoogleLogo = function GoogleLogo(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z",
    fill: "#4285F4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 23.002c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84c1.81 3.59 5.52 6.06 9.82 6.06z",
    fill: "#34A853"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09 0-.73.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12c0 1.78.43 3.45 1.18 4.93l2.85-2.22.81-.62z",
    fill: "#FBBC05"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z",
    fill: "#EA4335"
  }));
};

GoogleLogo.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var OutlookLogo = function OutlookLogo(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.907 8.945H18.8V.625a.594.594 0 0 0-.593-.595H9.907v8.915z",
    fill: "#5ACF5F"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.907 8.945V.03H.61a.594.594 0 0 0-.593.594v8.321h8.891z",
    fill: "#F84437"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.907 9.945H.016v8.322c0 .328.265.594.593.594h8.298V9.945z",
    fill: "#2299F8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.907 9.945v8.916h8.299a.594.594 0 0 0 .593-.594V9.945H9.907z",
    fill: "#FFC107"
  })));
};

OutlookLogo.defaultProps = {
  width: "19",
  height: "19",
  viewBox: "0 0 19 19",
  xmlns: "http://www.w3.org/2000/svg"
};
var CalendarType;

(function (CalendarType) {
  CalendarType["Google"] = "google";
  CalendarType["Outlook"] = "outlook";
  CalendarType["ChiliPiper"] = "chilipiper";
})(CalendarType || (CalendarType = {}));

var ChooseCalendar = function ChooseCalendar(_ref) {
  var actionValue = _ref.actionValue,
      onActionChange = _ref.onActionChange;
  var hasChiliPiperFF = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.CHILIPIPER_INTEGRATION));

  var _useChiliPiperIntegra = (0, _PersonalIntegration.useChiliPiperIntegration)(),
      chiliPiperUrl = _useChiliPiperIntegra.url;

  var _useCalendarIntegrati = (0, _useCalendarIntegration.useCalendarIntegration)(),
      currentIntegration = _useCalendarIntegrati.currentIntegration;

  var isChiliPiperAvailable = hasChiliPiperFF && chiliPiperUrl !== null;
  var isGoogleCalendarAvailable = (currentIntegration === null || currentIntegration === void 0 ? void 0 : currentIntegration.useCalendarIntegration.enabled) && (currentIntegration === null || currentIntegration === void 0 ? void 0 : currentIntegration.name) === _personalIntegration.CalendarName.Google;
  var isOutlookCalendarAvailable = (currentIntegration === null || currentIntegration === void 0 ? void 0 : currentIntegration.useCalendarIntegration.enabled) && (currentIntegration === null || currentIntegration === void 0 ? void 0 : currentIntegration.name) === _personalIntegration.CalendarName.Outlook;
  var isSomeCalendarIntegrationAvailable = isChiliPiperAvailable || isGoogleCalendarAvailable || isOutlookCalendarAvailable;
  var onChange = (0, _react.useCallback)(function (event) {
    var value = event.target.value;
    onActionChange(value);
  }, [onActionChange]);
  (0, _react.useEffect)(function () {
    if (actionValue === true && isSomeCalendarIntegrationAvailable) {
      switch (true) {
        case isGoogleCalendarAvailable:
          onActionChange(CalendarType.Google);
          break;

        case isOutlookCalendarAvailable:
          onActionChange(CalendarType.Outlook);
          break;

        case !isGoogleCalendarAvailable && !isOutlookCalendarAvailable && isChiliPiperAvailable:
          onActionChange(CalendarType.ChiliPiper);
          break;

        default:
          break;
      }
    }
  }, [actionValue, isChiliPiperAvailable, isGoogleCalendarAvailable, isOutlookCalendarAvailable, isSomeCalendarIntegrationAvailable, onActionChange]);
  if (!isSomeCalendarIntegrationAvailable) return null;
  return /*#__PURE__*/_react.default.createElement(_material.RadioGroup, {
    name: "calendar",
    value: actionValue,
    onChange: onChange
  }, isGoogleCalendarAvailable && /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    value: CalendarType.Google,
    control: /*#__PURE__*/_react.default.createElement(_material.Radio, null),
    label: /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true,
      alignItems: "center",
      columnSpacing: 1
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true,
      maxHeight: 24
    }, /*#__PURE__*/_react.default.createElement(GoogleLogo, {
      width: 24,
      height: 24
    })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, "Use Google calendar for book meeting")))
  }), isOutlookCalendarAvailable && /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    value: CalendarType.Outlook,
    control: /*#__PURE__*/_react.default.createElement(_material.Radio, null),
    label: /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true,
      alignItems: "center",
      columnSpacing: 1
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true,
      maxHeight: 24
    }, /*#__PURE__*/_react.default.createElement(OutlookLogo, {
      width: 24,
      height: 24
    })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, "Use Outlook calendar for book meeting")))
  }), /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    value: CalendarType.ChiliPiper,
    disabled: !isChiliPiperAvailable,
    control: /*#__PURE__*/_react.default.createElement(_material.Radio, null),
    label: /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true,
      alignItems: "center",
      columnSpacing: 1
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true,
      maxHeight: 24
    }, /*#__PURE__*/_react.default.createElement(ChiliPiperLogo, {
      width: 24,
      height: 24
    })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, "Use Chili Piper for book meeting ")))
  }));
};

var _default = ChooseCalendar;
exports.default = _default;